import {
  Component,
  HostListener,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation
} from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import {
  LgButtonComponent,
  LgGridColDirective,
  LgGridContainerDirective,
  LgGridRowDirective,
  LgSpinnerComponent,
  LgSelectDirective,
  LgSelectFieldComponent
} from "@legal-and-general/canopy";
import { Store } from "@ngrx/store";
import { ContentApiService } from "../../../services/api/content-api.service";
import { ComponentLoaderService } from "../../../services/component-loader/component-loader.service";
import { GlobalState } from "../../../store/global/global.reducer";
import { DynamicComponentItem } from "../../utils/dynamic-loader/dynamic-component-item";
import { LoaderComponent } from "../../utils/dynamic-loader/loader.component";
import { BaseLayoutComponent } from "../BaseLayout/BaseLayout.component";
import { Observable } from "rxjs";
import { FormsModule } from "@angular/forms";
import { selectPageTitle } from "../../../store/global/global.selectors";
import { AnalyticsService } from "../../../services/analytics/analytics.service";
import { NgClass } from "@angular/common";
import { CookieService } from "../../../services/cookie/cookie.service";

@Component({
  selector: "dotcom-frontend-blog-home-page",
  templateUrl: "./BlogHomeLayout.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrl: "./BlogHomeLayout.component.scss",
  standalone: true,
  imports: [
    LgGridRowDirective,
    LgGridContainerDirective,
    LgGridColDirective,
    LoaderComponent,
    LgSpinnerComponent,
    LgButtonComponent,
    NgClass,
    LgSelectDirective,
    LgSelectFieldComponent,
    FormsModule
  ]
})
export class BlogHomeLayoutComponent
  extends BaseLayoutComponent
  implements OnInit
{
  pageTitle$: Observable<string> = this.store.select(selectPageTitle);
  pageTitle = "";
  blogList: Array<DynamicComponentItem | undefined> | undefined;
  pageStyle: any | undefined;
  showLoadMore = false;
  showSpinner = false;
  page = 1;
  indexPageId = 0;
  filterOption = "0";
  communityGroups: Array<any> | undefined;
  isBrowser = isPlatformBrowser(this.platformId);
  isFunctionalCookiesAccepted = true;
  ifCommunities = false;

  constructor(
    private contentApiService: ContentApiService,
    private cookieService: CookieService,
    store: Store<{ global: GlobalState }>,
    componentLoaderService: ComponentLoaderService,
    private analyticsService: AnalyticsService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    super(store, componentLoaderService);
    this.pageTitle$.subscribe((title) => {
      this.pageTitle = title;
    });
  }

  @HostListener("window:load", ["$event"])
  onLoad() {
    this.checkFunctionalCookies();
  }

  override async ngOnInit() {
    await super.ngOnInit();
    this.blogList = [];
    if (this.data) {
      if (this.data["enableCommunities"]) {
        this.ifCommunities = true;
        this.communityGroups = this.data["communityGroups"];
      }

      if (this.data["contentLink"] && this.data["contentLink"]["id"]) {
        this.indexPageId = this.data["contentLink"]["id"];

        const cookieName = `audience`;
        const filterOptionCookie = this.cookieService.getCookie(cookieName);
        if (filterOptionCookie !== null && this.ifCommunities) {
          this.filterOption = filterOptionCookie;
        }
        this.loadBlogList(this.indexPageId, 1, this.filterOption);
      }
    }
  }

  checkFunctionalCookies() {
    if ((window as any).OnetrustActiveGroups) {
      if ((window as any).OnetrustActiveGroups.includes("3")) {
        this.isFunctionalCookiesAccepted = true;
      }
    }
  }

  applyFilters(event: any) {
    event.stopPropagation();
    this.showLoadMore = false;
    const cookieName = `audience`;
    this.blogList = [];
    if (this.filterOption === "0") {
      this.cookieService.eraseCookie(cookieName);
    } else {
      if (this.isFunctionalCookiesAccepted) {
        this.cookieService.setCookie(cookieName, this.filterOption, 365);
      }
    }
    this.loadBlogList(this.data["contentLink"]["id"], 1, this.filterOption);
  }

  loadBlogList(indexPageId: number, page: number, filterOption: any) {
    this.showSpinner = true;
    this.contentApiService
      .getBlogList(indexPageId, page, filterOption)
      .subscribe(async (response) => {
        if (response && response["results"] && this.blogList) {
          for (const item of response["results"]) {
            this.blogList.push(
              await this.componentLoaderService.loadComponent(
                "ArticleCardBlock",
                "blocks",
                {
                  articleData: item,
                  pageStyle: "blogarticlelisting"
                }
              )
            );
          }

          this.showSpinner = false;

          if (response.totalMatching > this.blogList.length && page < 10) {
            this.showLoadMore = true;
            this.page = page;
          } else {
            this.showLoadMore = false;
          }
        }
      });
  }

  getColSpan(index: number) {
    const tenCards = index % 5;
    if (tenCards === 1 || tenCards === 2) {
      return 6;
    } else {
      return 4;
    }
  }

  interactionClickEvent(clickUrl: any, clickName: any) {
    this.analyticsService.adobeInteractionEvent(
      "Author Page",
      clickUrl,
      clickName,
      "",
      "LinkClick",
      this.pageTitle,
      ""
    );
  }
}
